import { Link } from "react-router-dom";
import { CalendarCheck, Lock } from "lucide-react";

export const TopPathReveal = ({ top, total }) => (
  <div className="max-w-2xl mx-auto px-5 pt-8 pb-16" data-testid="top-path-reveal">
    <div className="eyebrow text-[#FD0F10]">YOUR #1 PATH</div>
    <h1 className="mt-2 font-display text-3xl sm:text-4xl font-black leading-tight" data-testid="reveal-title">{top.title}</h1>
    {top.fit_reason && <p className="mt-3 text-base text-gray-200 leading-relaxed" data-testid="reveal-fit">{top.fit_reason}</p>}
    <div className="mt-5 grid grid-cols-2 gap-2 text-sm">
      <div className="card-panel p-3"><div className="text-xs text-gray-500 font-mono-ui">TIME</div><div className="text-white mt-1" data-testid="reveal-time">{top.time}</div></div>
      <div className="card-panel p-3"><div className="text-xs text-gray-500 font-mono-ui">EARNINGS</div><div className="text-white mt-1" data-testid="reveal-income">{top.income_potential}</div></div>
    </div>
    <p className="mt-2 text-[11px] text-gray-500" data-testid="reveal-disclaimer">Results depend on your effort. The more hours you put in, the faster it usually grows. Most people earn less at first, and that's normal.</p>
    {top.sprint_day1 && (
      <div className="mt-5 card-panel p-4" data-testid="reveal-sprint">
        <div className="flex items-center gap-2 eyebrow text-[#FD0F10]"><CalendarCheck size={13} /> 7-DAY LAUNCH SPRINT</div>
        <p className="mt-2 text-sm text-gray-200">Day 1: {top.sprint_day1}</p>
        <p className="mt-1 text-xs text-gray-500 flex items-center gap-1"><Lock size={11} /> Days 2 to 7 unlock with your free account.</p>
      </div>
    )}
    <div className="mt-7 card-panel-elevated p-5 text-center">
      <p className="text-white font-bold" data-testid="reveal-cta-text">Create a free account to save this, see your other paths, and start your 7-day sprint.</p>
      <Link to="/auth?next=/dashboard" className="mt-4 block hero-accent text-white font-display font-bold text-lg py-4 rounded-lg" data-testid="reveal-signup-btn">Create My Free Account</Link>
      {total > 1 && <p className="mt-2 text-xs text-gray-400">{total - 1} more paths are waiting for you.</p>}
    </div>
  </div>
);
